
<vue-context ref="menu">
    <li>
        <a class="clickable" v-on:click="openNewTab">
            {{ $t("navigationContextMenu.openNewTab") }}
        </a>
    </li>
    <li>
        <a class="clickable" v-on:click="openNewWindow">
            {{ $t("navigationContextMenu.openNewWindow") }}
        </a>
    </li>
    <li>
        <a class="clickable" v-on:click="copyToClipboard">
            {{ $t("navigationContextMenu.copyToClipboard") }}
        </a>
    </li>
</vue-context>
